import { useEffect } from 'react'

export default function useDebounce(
  callback: () => void,
  delay: number,
  dependencies: any[]
) {
  useEffect(() => {
    const timeoutId = setTimeout(callback, delay)

    return () => {
      clearInterval(timeoutId)
    }
  }, dependencies)
}
